import jQuery from "jquery";
import jQueryUjs from "@railslts/jquery-ujs";

window.jQuery = window.$ = jQuery;
jQueryUjs(jQuery);
